<template>
  <b-card no-body>
    <b-card-header class="border-0">
      <h3 class="mb-0">Listado de archivos</h3>
    </b-card-header>
    <b-list-group>
      <b-list-group-item v-for="file of list" :key="file._id" class="d-flex justify-content-between border">
        <span>{{file.title}}</span>

        <b-button-group size="sm">
          <a :href="file.file" title="Ver o descar archivo" class="btn btn-primary" target="_blank">
            <i class="ni ni-cloud-download-95"></i>
          </a>
          <b-button @click="deleteFile(file)" variant="danger">
            <i class="ni ni-fat-remove"></i>
          </b-button>
        </b-button-group>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "FaqFileList",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      list: [],
      search: '',
    };
  },
  methods: {
    getList() {
      get("faqs/files", null, true).then(({data}) => {
        this.list = data
      })
    },
    deleteFile(file) {
      post("faqs/delete-file/" + file._id, null, true).then(() => {
        this.getList()
        this.showMessage('Archivo eliminado')
      })
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
  },
  mounted() {
    this.getList()
  },
}
</script>

<style scoped>

</style>
